import "babel-polyfill";
import "./libs/slick";
import "./libs/infiniteslidev2"
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {stickyHeader} from "./modules/stickyHeader";
import {mobileNav} from "./modules/mobileNav";
import {anchorLinks} from "./modules/anchorLinks";
import {animationOnScroll} from "./modules/animationOnScroll";
import {servicesSlider} from "./modules/servicesSlider";
import {successSlider} from "./modules/successSlider";
import {footerMobileMenu} from "./modules/footerMobileMenu";
import {awardsLogosSlider} from "./modules/awardsLogosSlider";
import {heroSlider} from "./modules/heroSlider";
import {popups} from "./modules/popups";
import {customSelect} from "./modules/customSelect";
import {countersAnimation} from "./modules/countersAnimation";
import {industriesAnimation} from "./modules/industriesAnimation";
import {testimonialsSlider} from "./modules/testimonialsSlider";
import {postsSlider} from "./modules/postsSlider";
import {accordion} from "./modules/accordion";
import {newsSlider} from "./modules/newsSlider";
import {testimonialsPagination} from "./modules/testimonialsPagination";
import {postFilters} from "./modules/postFilters";
import {video} from "./modules/video";
import {imagesSlider} from "./modules/imagesSlider";
import {historySlider} from "./modules/historySlider";
import {hash} from "./modules/hash";
import { logosSlider } from "./modules/logosSlider";
import {subscribeForm} from "./modules/subscribeForm";

binder({
    bounds: {
        html: [constants, fullHeightPage, hash],
        ".header": [stickyHeader, mobileNav, anchorLinks],
        ".footer": footerMobileMenu,
        ".has-animation": animationOnScroll,
        ".services-slider": servicesSlider,
        ".success-slider": successSlider,
        ".awards-logos-slider": awardsLogosSlider,
        ".hero-slider": heroSlider,
        ".popup-link": popups,
        "select": customSelect,
        ".has-counters-animation": countersAnimation,
        ".industries-content": industriesAnimation,
        ".testimonials-slider": testimonialsSlider,
        ".posts-slider": postsSlider,
        ".accordion": accordion,
        ".news-slider": newsSlider,
        ".testimonials": testimonialsPagination,
        ".resources": postFilters,
        ".video-holder": video,
        ".images-slider": imagesSlider,
        ".history-slider": historySlider,
        ".logos-slider": logosSlider,
        ".subscribe-section": subscribeForm
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js